import React from "react";
import {useFormik} from "formik";

import {RegisterBody} from "../../interfaces/auth.insterface";
import { MDBContainer, MDBIcon, MDBInput} from "mdb-react-ui-kit";

import * as Yup from 'yup';
import {Typography, Alert} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import {registerUser, RegisterInterface} from '../../services/auth_request'
import LoadingButton from "../../componentes/LoadingButton";

const Register:React.FC = () =>{
    const navigate = useNavigate();
    const [showPassword1, setShowPassword1] = React.useState(false);
    const toggleShowPassword1 = () => setShowPassword1(!showPassword1);
    const [showPassword2, setShowPassword2] = React.useState(false);
    const toggleShowPassword2 = () => setShowPassword2(!showPassword2);
    const formik = useFormik<RegisterBody>({
        initialValues:{
            pre_reg_last_name: '',
            pre_reg_first_name: '',
            pre_reg_email: '',
            pre_reg_password: '',
            password_1:'',
            password_2:''
        },
        validationSchema: Yup.object({
            password_1: Yup.string()
                .required('La contraseña es obligatoria')
                .min(8, 'La contraseña debe tener al menos 8 caracteres')
                .matches(
                    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    'Debe contener al menos una mayúscula, un número y un carácter especial (@$!%*?&)'
                ),
            password_2: Yup.string()
                .required('Debes confirmar tu contraseña')
                .oneOf([Yup.ref('password_1')], 'Las contraseñas no coinciden'),
            pre_reg_last_name: Yup.string()
                .required('Se debe ingresar un Apellido'),
            pre_reg_first_name: Yup.string()
                .required('Se debe ingresar un Nombre'),
            pre_reg_email: Yup.string()
                .email('Ingresa un correo electrónico válido')
                .required('Se debe ingresar un email'),
        })
        ,
        onSubmit: async (values, {setSubmitting})=>{
            console.log(values)
            let password = ''
            if (values.password_2 && values.password_1){
                password = values.password_2
            }
            const body:RegisterInterface = {
                pre_reg_last_name: values.pre_reg_last_name,
                pre_reg_first_name: values.pre_reg_first_name,
                pre_reg_username: `${values.pre_reg_first_name}${values.pre_reg_last_name}`,
                pre_reg_email: values.pre_reg_email,
                pre_reg_password: password
            }
            const response = await registerUser(body)
            if (response === 200) navigate(`/re_code/${values.pre_reg_email}`)
            setSubmitting(false)
        }
    })

    React.useEffect(() => {
        console.log("Errors:", formik.errors);
        console.log("Touched:", formik.touched);
    }, [formik.errors, formik.touched]);

    return<>
        <MDBContainer className="p-1 my-5 d-flex flex-column w-75" style={{ maxWidth: '500px' }}>
            <form onSubmit={formik.handleSubmit}>
                <Typography fontWeight={700} variant='h5' textAlign={"center"}>Registrate</Typography>

                <br />
                <MDBInput
                    wrapperClass='mb-2'
                    label='Nombre'
                    name='pre_reg_first_name'
                    id='pre_reg_first_name'
                    onChange={formik.handleChange}
                    autoComplete={"off"}
                    onBlur={formik.handleBlur}
                    value={formik.values.pre_reg_first_name}
                    type='text'
                />
                <MDBInput
                    wrapperClass='mb-2'
                    label='Apellido'
                    name='pre_reg_last_name'
                    id='pre_reg_last_name'
                    onChange={formik.handleChange}
                    autoComplete={"off"}
                    onBlur={formik.handleBlur}
                    value={formik.values.pre_reg_last_name}
                    type='text'
                />
                <MDBInput
                    wrapperClass='mb-2'
                    label='Email address'
                    name='pre_reg_email'
                    id='pre_reg_email'
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    autoComplete={"off"}
                    value={formik.values.pre_reg_email}
                    type='email'

                />
                <div className="mb-2" style={{ position: 'relative' }}>
                    <MDBInput
                        label='Password'
                        name='password_1'
                        id='password_1'
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        autoComplete={"new-password"}
                        type={showPassword1 ? 'text' : 'password'}
                        value={formik.values.password_1}
                    />
                    <MDBIcon
                        icon={showPassword1 ? 'eye' : 'eye-slash'}
                        className="far"
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                        onClick={toggleShowPassword1}
                    />
                </div>
                {/* Mostrar errores si existe */}

                <div className="mb-2" style={{ position: 'relative' }}>
                    <MDBInput
                        label='Confirmar Password'
                        name='password_2'
                        id='password_2'
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        autoComplete={"new-password"}
                        type={showPassword2 ? 'text' : 'password'}
                        value={formik.values.password_2}
                    />
                     <MDBIcon
                        icon={showPassword2 ? 'eye' : 'eye-slash'}
                        className="far"
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                        onClick={toggleShowPassword2}
                    />
                </div>
                {formik.touched.pre_reg_first_name && formik.errors.pre_reg_first_name ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.pre_reg_first_name}</Alert>
                  ) : null}
                {formik.touched.pre_reg_last_name && formik.errors.pre_reg_last_name ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.pre_reg_last_name}</Alert>
                  ) : null}
                {formik.touched.pre_reg_email && formik.errors.pre_reg_email ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.pre_reg_email}</Alert>
                  ) : null}
                {formik.touched.password_1 && formik.errors.password_1 ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.password_1}</Alert>
                  ) : null}
                {formik.touched.password_2 && formik.errors.password_2 ? (
                    <Alert severity={'info'} color={'warning'}>{formik.errors.password_2}</Alert>
                ) : null}
                <div className="d-flex justify-content-between mx-3 mb-4">
                {/* <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' /> */}
                <a href="/login">Ya tiene una cuenta?</a>
                </div>

                <LoadingButton className="mb-4" variant={"contained"} color={"primary"} type='submit' disabled={!formik.isValid || !formik.dirty} loading={formik.isSubmitting}>Registrarse</LoadingButton>
            </form>


        {/* <div className="text-center">
            <p>Not a member? <a href="#!">Register</a></p>
            <p>or sign up with:</p>

            <div className='d-flex justify-content-between mx-auto' style={{width: '40%'}}>
                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='facebook-f' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='twitter' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='google' size="sm"/>
                </MDBBtn>

                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#1266f1' }}>
                <MDBIcon fab icon='github' size="sm"/>
                </MDBBtn>

            </div>
        </div> */}

        </MDBContainer>
    </>
}

export default  Register